var _style, _g, _g2, _path, _ellipse, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9F9F9;}\n\t.st1{fill:#E0E1E1;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:12;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.29,261.27c2.67-3.13,4.63-6.5,5.9-10.1c1.27-3.6,1.9-6.87,1.9-9.8c0-4.13-1.2-8.2-3.6-12.2 s-5.4-8.03-9-12.1c-1.4-1.58-2.86-3.16-4.36-4.74v56.32C202.77,266.62,205.83,264.16,208.29,261.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.13,2.59V130.9c5.6-1.15,11.32-1.73,17.16-1.73c5.47,0,10.53,0.27,15.2,0.8 c4.67,0.53,8.08,1.21,11.42,2.28c3.33,1.07,5.93,2.43,7.8,4.1c1.87,1.67,2.8,3.63,2.8,5.9c0,3.07-0.7,6.43-2.1,10.1 c-1.4,3.67-3.17,7.1-5.3,10.3c-2.13,3.2-4.4,5.87-6.8,8c-2.4,2.13-4.6,3.2-6.6,3.2c-1.33,0-1.42-1.28-1.42-4.08 c0-1.47,0.1-3.17,0.3-5.1c0.2-1.93,0.3-3.97,0.3-6.1c0-2.4-0.2-4.77-0.6-7.1c-0.4-2.33-1.27-4.47-2.6-6.4 c-1.33-1.93-3.2-3.5-5.6-4.7c-2.4-1.2-5.6-1.8-9.6-1.8c-2.53,0-5.07,0.37-7.6,1.1c-2.48,0.72-4.73,1.79-6.76,3.21v30.09 c1.77,2.24,3.75,4.51,5.96,6.8c3.73,3.87,7.77,7.8,12.1,11.8c4.33,4,8.37,8.23,12.1,12.7c3.73,4.47,6.83,9.2,9.3,14.2 c2.47,5,3.7,10.3,3.7,15.9c0,8.13-1.77,15.2-5.3,21.2c-3.53,6-8.17,11-13.9,15c-5.73,4-12.13,7-19.2,9 c-1.59,0.45-3.18,0.84-4.76,1.19v116.65L353.03,200L199.13,2.59z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.99,148.67c-1.27,2.33-1.9,5.17-1.9,8.5c0,3.73,1.23,7.47,3.7,11.2c1.01,1.52,2.12,3.06,3.34,4.6v-30.09 c-0.05,0.03-0.09,0.06-0.14,0.09C196.92,144.44,195.25,146.34,193.99,148.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.89,282.57c-6.13,0-11.9-0.7-17.3-2.1c-5.4-1.4-10.1-3.43-14.1-6.1c-4-2.67-7.17-6.03-9.5-10.1 c-2.33-4.07-3.5-8.7-3.5-13.9c0-3.33,0.57-6.9,1.7-10.7c1.13-3.8,3-7.27,5.6-10.4c2.6-3.13,6.03-5.73,10.3-7.8 c4.27-2.07,9.41-1.8,15.68-1.8c3.33,0,5,0.67,5,2c0,1.33-1.4,3.33-4.2,6c-4.13,3.87-6.31,6.63-7.98,11.03 c-1.67,4.4-3.1,8.87-3.1,13.27c0,2.4,0.43,4.8,1.3,7.2c0.87,2.4,2.2,4.6,4,6.6c1.8,2,4.1,3.6,6.9,4.8c2.8,1.2,6.13,1.8,10,1.8 c5.6,0,10.43-1.07,14.5-3.2c0.32-0.17,0.63-0.34,0.94-0.52v-56.32c-2.36-2.49-4.83-4.97-7.44-7.46c-4.27-4.07-8.2-8.23-11.8-12.5 c-3.6-4.27-6.6-8.67-9-13.2c-2.4-4.53-3.6-9.2-3.6-14c0-6.67,1.4-12.3,4.2-16.9s6.5-8.3,11.1-11.1c4.6-2.8,9.83-4.83,15.7-6.1 c0.28-0.06,0.56-0.11,0.84-0.17V2.59L46.97,200l152.16,197.41V280.76C193.67,281.97,188.26,282.57,182.89,282.57z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M259.89,68.34c37.89-12.44,70.22-10.7,87.82,8.16c34.77,37.28-1.15,127.3-80.24,201.06 S96.09,380.92,61.32,343.64c-20.3-21.76-16.5-61.51,5.91-105.5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 123.56,
    cy: 357.25,
    rx: 19.44,
    ry: 20.22
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 306.74,
    cy: 60.78,
    rx: 19.44,
    ry: 20.22
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d654a87e51a37a1dd03787c0a9c699b9.svg";
export { ForwardRef as ReactComponent };